app.filter('toDate', () => {
	return (date) => {
		return date
			? moment(date).toDate()
			: moment().startOf('day').toDate();
	};
});
